export const mcString = {
  /**
   * Determine if leftString is before, after, or equal to rightString
   * @param {string} leftString string to compare and see if it's before or after right string
   * @param {string} rightString string to compare and see if it's before or after left string
   * @retuns {number} -1 if leftString is before rightString, 0 if they are the same, 1 if leftString is after rightString
   */
  isAfter(leftString: string, rightString: string): number {
    let result = leftString.localeCompare(rightString, 'en', { sensitivity: 'base' });
    return result;
  },

  /**
   * Convert "a string value" to "A String Value"
   * @param {string} str The string to convert to Title Case
   * @returns {string} Returns a Title Case version of the string passed in
   */
  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (text) { return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase(); });
  }
}
